import { Component } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { AsyncPipe, NgStyle } from '@angular/common';
import { Observable } from 'rxjs/internal/Observable';
import { ResponsiveService } from '../../services/reponsive.service';
import { TranslateModule } from '@ngx-translate/core';
import { PricingComponent } from "../../components/pricing/pricing.component";
import { ButtonComponent } from "../../components/boutons/button/button.component";
import { Store } from '@ngrx/store';
import { selectClientPlan, selectClientTokensPerMonth } from '../../store/client/client.selects';
import { Plan } from '../../class/plan.class';

@Component({
  selector: 'app-plans',
  imports: [LucideAngularModule, TranslateModule, NgStyle, PricingComponent, AsyncPipe],
  templateUrl: './plans.component.html',
  styleUrl: './plans.component.scss'
})
export class PlansComponent {
  isDesktop$: Observable<boolean> = this.responsiveService.desktop$;
  tokensPerMonth$: Observable<number> = this.store.select(selectClientTokensPerMonth)

  clientPlan$:Observable<Plan | null> = this.store.select(selectClientPlan)
  constructor(
    private responsiveService: ResponsiveService,
    private store: Store
  ) { }
}
